import { MainPhotoSection } from "../MainPage/MainPageStyles";
import { AccessibleMarketsSections } from "./MarketPageStyles";
import { MSectionCard } from "../../components/SectionCard/SectionCard";
import MarketMainPhoto from "../../images/marketMainImg.png";
import { MCardWithImgAndTitle } from "../../components/Cards/CardWithImgAndTitle/CardWithImgAndTitle";
import Stock from "../../images/CardsImages/MarketsCardsIcons/stock.svg";
import Commod from "../../images/CardsImages/MarketsCardsIcons/commodities.svg";
import Index from "../../images/CardsImages/MarketsCardsIcons/index.svg";
import Forex from "../../images/CardsImages/MarketsCardsIcons/forex.svg";
import Crypto from "../../images/CardsImages/MarketsCardsIcons/crypto.svg";
import StockSectionImg from "../../images/MarketSectionCardsImg/stock.webp";
import CommodSectionImg from "../../images/MarketSectionCardsImg/commodities.webp";
import IndexSectionImg from "../../images/MarketSectionCardsImg/index.jpg";
import ForexSectionImg from "../../images/MarketSectionCardsImg/forex.jpg";
import CryptoSectionImg from "../../images/MarketSectionCardsImg/crypto.jpg";
import FinFreedom from "../../images/MarketSectionCardsImg/fin-freedom.jpg";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
} from "../../animations/animations";
import { useTranslation } from "react-i18next";

export const MarketPage = () => {
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between flex__column"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("marketsPage.title1")}</h1>
            <p className="big__text">{t("marketsPage.title2")}</p>
            <p>{t("marketsPage.title3")}</p>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={MarketMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <AccessibleMarketsSections>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("marketsPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="cards__container"
          >
            <MCardWithImgAndTitle
              custom={1}
              variants={arrAnimation}
              img={Stock}
              title={`${t("marketsPage.blockInfo11")}`}
              width="48%"
              key={"marketCardWithImg1"}
            />
            <MCardWithImgAndTitle
              custom={2}
              variants={arrAnimation}
              img={Commod}
              title={`${t("marketsPage.blockInfo12")}`}
              width="48%"
              key={"marketCardWithImg2"}
            />
            <MCardWithImgAndTitle
              custom={3}
              variants={arrAnimation}
              img={Index}
              title={`${t("marketsPage.blockInfo13")}`}
              width="31%"
              key={"marketCardWithImg3"}
            />
            <MCardWithImgAndTitle
              custom={4}
              variants={arrAnimation}
              img={Crypto}
              title={`${t("marketsPage.blockInfo14")}`}
              width="31%"
              key={"marketCardWithImg4"}
            />
            <MCardWithImgAndTitle
              custom={5}
              variants={arrAnimation}
              img={Forex}
              title={`${t("marketsPage.blockInfo15")}`}
              width="31%"
              key={"marketCardWithImg5"}
            />
          </motion.div>
        </div>
      </AccessibleMarketsSections>
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        background="rgb(0, 27, 72)"
        title={`${t("marketsPage.blockInfo211")}`}
        text={`${t("marketsPage.blockInfo212")}`}
        img={StockSectionImg}
        key={"marketSectionCard1"}
      />
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        flexDirection="row-reverse"
        right="0"
        left="auto"
        background="#03495f"
        title={`${t("marketsPage.blockInfo221")}`}
        text={`${t("marketsPage.blockInfo222")}`}
        img={CommodSectionImg}
        key={"marketSectionCard2"}
      />
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        flexDirection="row-reverse"
        right="0"
        left="auto"
        background="rgb(0, 27, 72)"
        title={`${t("marketsPage.blockInfo231")}`}
        text={`${t("marketsPage.blockInfo232")}`}
        img={IndexSectionImg}
        key={"marketSectionCard3"}
      />
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        background="#03495f"
        title={`${t("marketsPage.blockInfo241")}`}
        text={`${t("marketsPage.blockInfo242")}`}
        img={CryptoSectionImg}
        key={"marketSectionCard4"}
      />
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        background="#071B40"
        title={`${t("marketsPage.blockInfo251")}`}
        text={`${t("marketsPage.blockInfo252")}`}
        img={ForexSectionImg}
        key={"marketSectionCard5"}
      />
      <MSectionCard
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
        custom={1}
        variants={arrAnimation}
        flexDirection="row-reverse"
        right="0"
        left="auto"
        background="rgb(3, 73, 95)"
        link={true}
        title={`${t("marketsPage.blockInfo261")}`}
        img={FinFreedom}
        key={"marketSectionCard6"}
      />
    </main>
  );
};
